import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import PropTypes from 'prop-types';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import { ObjectPropsPropType } from '../../../../services/proptypes';
var propTypes = {
  collection: PropTypes.arrayOf(ObjectPropsPropType).isRequired,
  predicate: PropTypes.oneOfType([ObjectPropsPropType, PropTypes.func, PropTypes.arrayOf(PropTypes.any)]),
  targetFields: PropTypes.arrayOf(PropTypes.string)
};
var defaultProps = {
  predicate: {},
  targetFields: []
};
export default function Find(_ref) {
  var collection = _ref.collection,
    predicate = _ref.predicate,
    targetFields = _ref.targetFields;
  // See lodash find: https://lodash.com/docs/4.17.15#find
  var foundItem = _find(collection, predicate);
  if (_isEmpty(foundItem)) {
    return null;
  }
  if (_isEmpty(targetFields)) {
    return foundItem;
  }
  if (targetFields.length === 1) {
    return foundItem[targetFields[0]];
  }
  return targetFields.reduce(function (acc, field) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, field, foundItem[field]));
  });
}
Find.propTypes = propTypes;
Find.defaultProps = defaultProps;